import api from "../../client";
import { TagListResponseData } from "../../types/tag";
import { useQuery } from "react-query";
import { queryKeys } from "../../query";

export interface TagQueryParams {
  search?: string;
}

export const tagListRequest = async (params?: TagQueryParams) => {
  const { data } = await api.get<TagListResponseData>(`/tags`, { params });
  return data;
};

export const useTagList = (params?: TagQueryParams) => {
  return useQuery<TagListResponseData>(
    queryKeys.tagList(params),
    () => tagListRequest(params),
    { keepPreviousData: true },
  );
};
